import { Route } from "@angular/router";
import { ReceiptLayout } from "../pages/receipt/receipt.layout";
import { ReceiptListLayout } from "../pages/receipt/pages/list/receipt-list.layout";
import { ReceiptPermissions } from "@malirang/common";
import AbnormalPaymentLayout from "../pages/receipt/pages/abnormal-payment/abnormal-payment.layout";

export const receiptRoutes: Route[] = [
    {
        path: "receipt",
        component: ReceiptLayout,
        data: {
            requiredRoles: [ReceiptPermissions.RECEIPT_READ_ALL],
        },
        children: [
            {
                path: "",
                pathMatch: "full",
                redirectTo: "today",
            },
            {
                path: "abnormal-payment",
                component: AbnormalPaymentLayout,
                children: [
                    {
                        path: "",
                        redirectTo: "list",
                        pathMatch: "full",
                    },
                    {
                        path: "list",
                        loadComponent: () =>
                            import(
                                "../pages/receipt/pages/abnormal-payment/abnormal-payment-list/abnormal-payment-list"
                            ),
                    },
                    {
                        path: "usage",
                        loadComponent: () =>
                            import(
                                "../pages/receipt/pages/abnormal-payment/usage/usage"
                            ),
                    },
                    {
                        path: "failed-matching",
                        loadComponent: () =>
                            import(
                                "../pages/receipt/pages/abnormal-payment/failed-matching/failed-matching"
                            ),
                    },
                ],
            },
            {
                path: "today",
                loadComponent: () =>
                    import("../pages/receipt/pages/today/receipt-today.page"),
            },
            {
                path: "list",
                component: ReceiptListLayout,
                children: [
                    {
                        path: "",
                        redirectTo: "summary",
                        pathMatch: "full",
                    },
                    {
                        path: "summary",
                        loadComponent: () =>
                            import(
                                "../pages/receipt/pages/list/summary/summary.page"
                            ),
                    },
                    {
                        path: "month",
                        loadComponent: () =>
                            import(
                                "../pages/receipt/pages/list/month/month.page"
                            ),
                    },
                    {
                        path: "detail",
                        loadComponent: () =>
                            import(
                                "../pages/receipt/pages/list/detail/detail.page"
                            ),
                    },
                ],
            },
            {
                path: "total",
                loadComponent: () =>
                    import("../pages/receipt/pages/total/receipt-total.page"),
            },
            {
                path: "other-list",
                loadComponent: () =>
                    import(
                        "../pages/receipt/pages/other-list/receipt-other-list.page"
                    ),
            },
        ],
    },
];
